import { SuperSearch,SearchResult } from './search.model';

export default class SearchmodalService {

    /**
    * Posts an search request
    * @param SuperSearch
    */
    postSearch(search: SuperSearch): Promise<SearchResult[]> {
        return fetch('api/activity/search',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(search)
            })
            .then(response => response.json() as Promise<SearchResult[]>);
    }


}